import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "100vh",
    overflow: "auto",
    fontFamily: "Roboto",

    "@media all and (max-width: 900px)": {
      marginTop: 80,
    },
    "@media all and (max-width: 600px)": {
      width: "100%",
      marginTop: 80,
    },
  },
  boxtitle: {
    width: "80%",
    display: "flex",
    color: "#4B4952",
    marginLeft: "5%",
    marginTop: "1.5rem",
  },
  title: {
    fontSize: "2rem",
    letterSpacing: "0.04rem",
    "@media all and (max-width: 600px)": {
      fontSize: "1.5em",
    },
  },
  boxSubTitle: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    color: "#4B4952",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    // paddingBottom: 10,
    // paddingTop: 10,
    padding: "10px 0px",
    marginLeft: "5%",
    marginTop: "20px",
    "@media all and (max-width: 600px)": {
      fontSize: "0.8em",
    },
    "@media all and (min-width: 1500px)": {
      width: "60%",
    },
  },
  subtitle: {
    fontSize: "1rem",
    marginLeft: 8,
    fontWeight: "bold",
  },
  boxTable: {
    width: "95%",
    marginTop: "1rem",
    marginLeft: "5%",
  },
  boxButtonAdd: {
    marginTop: "1.2rem",
    marginLeft: "5.5%",
    display: "flex",
  },
  boxDetails: {
    width: "80%",
    marginLeft: "5%",
    marginTop: "2%",
    padding: "10px 0px",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    marginBottom: "5%",
    "@media all and (max-width: 850px)": {
      marginBottom: "10%",
    },
    "@media all and (min-width: 1500px)": {
      width: "60%",
    },
  },
  buttonCreateNotification: {
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 5,
    marginTop: "2%",
    marginLeft: "5%",
    border: "1px solid #dbdbdb",
    padding: 10,
    minWidth: "20%",
    maxWidth: "25%",
    borderLeft: "4px solid #00A88F",
    cursor: "pointer",
    color: "#008471",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.5)",
    },
  },
  buttons: {
    display: "flex",
    width: "90%",
    justifyContent: "flex-end",
  },
  confirmButton: {
    width: 120,
    height: 35,
    backgroundColor: "#03A696",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
    WebkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
    MozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
    borderRadius: "23px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media all and (max-width: 1000px)": {
      fontSize: "0.8em",
    },
  },
  confirmButtonTypography: {
    color: "#FFFFFF",
    cursor: "pointer",
    fontSize: 14,
    fontFamily: "Raleway",
    fontWeight: 700,
    fontStyle: "normal",
    letterSpacing: "0.05em",
    lineHeight: "21px",
  },
  dateSelector: {
    width: 100,
  },
  timeSelector: {
    maxWidth: "100%",
    "@media all and (max-width: 900px)": {
      '& input[type="time"]': {
        width: "100px",
      },
    },
  },
}))

export default useStyles
